import React, { useState, useEffect  } from 'react';
import { Helmet } from 'react-helmet';
import { message, Spin  } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import NavBar from '../components/Requests/NavBar';
import RequestsContent from '../components/Requests/RequestsContent';
import { API_URL, API_username, API_password } from '../utils/api';

function Requests() {
	useEffect(() => {
		getEmployeeRequests();
	}, []);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [employeeRequests, setEmployeeRequests] = useState([]);
	const [isAnnualLeaveRequestExist, setIsAnnualLeaveRequestExist] = useState(false);
	const [isUnpaidLeaveRequestExist , setIsUnpaidLeaveRequestExist] = useState(false);
	const [isResignationRequestExist , setIsResignationRequestExist] = useState(false);

	const getEmployeeRequests = () => {
		setLoading(true);
		let apiUrl = `${API_URL}/lk?method=GetEmployeeRequests&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				if(response.statusText === 'Session not found') {
					message.error('Сессия не найдена, авторизуйтесь заново!');
					navigate('/logout');
				} else {
					message.error('Метод не найден!');
				}
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				const sortedData = data.sort((a, b) => new Date(b.DocDate) - new Date(a.DocDate));
				const currentDate = new Date();
				setIsAnnualLeaveRequestExist(sortedData.some(doc => doc.DocType === "Решение об отпуске" && new Date(doc.DocDate).toDateString() === currentDate.toDateString()));
				setIsUnpaidLeaveRequestExist(sortedData.some(doc => doc.DocType === "Решение об отпуске без сохранения оплаты" && new Date(doc.DocDate).toDateString() === currentDate.toDateString()));
				setIsResignationRequestExist(sortedData.some(doc => doc.DocType === "Решение об увольнении" && new Date(doc.DocDate).toDateString() === currentDate.toDateString()));
        		setEmployeeRequests(sortedData);
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => setLoading(false));
	};
	

	return (
		<div>
			<Helmet>
				<title>Заявления работадателю - Личный кабинет Enter Engineering</title>
			</Helmet>			
			<div className='dashboard'>
				<NavBar />
				<div className='dashboard-content'>
					{loading && (<div className='loader-container'>
						<Spin size="large"/>
					</div>)}
                    <RequestsContent 
						employeeRequests={employeeRequests} 
						setLoading={setLoading} 
						isAnnualLeaveRequestExist={isAnnualLeaveRequestExist} 
						isUnpaidLeaveRequestExist={isUnpaidLeaveRequestExist} 
						isResignationRequestExist={isResignationRequestExist} 
					/>
				</div>
			</div>
		</div>
	);
}

export default Requests;
